import React, { forwardRef } from 'react';
import { Badge } from 'antd';

// Counts are operational data, not a capped approximation. Keep Ant's normal
// status/dot/Ribbon behavior and theme; only numeric overflow is overridden.
export const CountBadge = forwardRef(function CountBadge(props, ref) {
  return <Badge {...props} ref={ref} overflowCount={Infinity} />;
});
CountBadge.Ribbon = Badge.Ribbon;
